import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { ApiResponse } from '@shared/models';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { SnapshotModel } from '../models';
import { Client } from '../models/client.model';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    dummyFullNames = ['Jan Kowalski', 'Janusz Nowak', 'Barbara Kowalska', 'Elwira Nowak'];

    dummyCompanies = ['W.KRUK S.A', 'YES', 'APART', 'SLAVICKI'];

    dummyTestimonial =
        'W secesyjnej kamienicy w Opolu przy Rynku, pod arkadami, mieści się nasz salon firmowy, w którym przy lampce szampana lub filiżance pysznej kawy uzyskacie Państwo informacji na temat naszych obrączek oraz pierścionków zaręczynowych.';

    getClients(amount: number): Observable<Client[]> {
        const clients: Client[] = [];
        for (let index = 0; index < amount; index++) {
            const dummyClient: Client = {
                fullName: this.dummyFullNames[index],
                company: this.dummyCompanies[index],
                testimonial: this.dummyTestimonial,
                image: { url: `/assets/images/clients/client_${index}.png` },
            };
            clients.push(dummyClient);
        }
        return of(clients);
    }

    getSnapshots(): Observable<SnapshotModel[]> {
        return this.httpClient.get<ApiResponse<SnapshotModel[]>>('api/public/metrix/promoted').pipe(map((response) => response.data));
    }

    getEuroExchangeRate(): Observable<number> {
        return this.httpClient.post<ApiResponse<{ euro: number }>>('api/public/stelmach/alloy-prices', {}).pipe(map((response) => response.data.euro));
    }

    getSnapshotId(containerId: string): Observable<string> {
        return this.httpClient
            .skipApiPrefix()
            .skipErrorHandler()
            .post<{ snapshotId: string }>(`${environment.metrixUrl}api/proxy/snapshots`, {
                containerId,
            })
            .pipe(map((response) => response.snapshotId));
    }
}
